import { useDispatch } from "react-redux";
import { useMemo } from "react";
import {
  LOGIN,
  SERVICELIST,
  PRODUCTLIST,
  PRODUCTVIEW,
  SERVICEVIEW,
  COUPON,
  DISTANCE,
  NEWBOOKING,
  ORDERLIST,
  PAYMENTS,
  CREATECLIENT,
} from "../constants/actionTypes";
import agent from "../../agent";

export const useActions = () => {
  const dispatch = useDispatch();

  return useMemo(
    () => ({
      auth: (params) =>
        dispatch({
          type: LOGIN,
          payload: agent.Auth.login(params),
          successNotification: false,
        }),

      servicesList: (params, cb) =>
        dispatch({
          type: SERVICELIST,
          payload: agent.Services.list(params),
          callback: cb,
        }),

      productsList: (params, cb) =>
        dispatch({
          type: PRODUCTLIST,
          payload: agent.Services.products(params),
          callback: cb,
        }),

      productsView: (params, cb) =>
        dispatch({
          type: PRODUCTVIEW,
          payload: agent.Services.products_view(params),
          callback: cb,
        }),

      servicesView: (params, cb) =>
        dispatch({
          type: SERVICEVIEW,
          payload: agent.Services.view(params),
          callback: cb,
        }),

      coupons: (params, urlParams, cb) =>
        dispatch({
          type: COUPON,
          payload: agent.Services.promo_code(params, urlParams),
          callback: cb,
        }),
      distance: (params, callback) =>
        dispatch({
          type: DISTANCE,
          payload: agent.Auth.google_location(params),
          callback: callback,
        }),
      createClient: (params, callback) =>
        dispatch({
          type: CREATECLIENT,
          payload: agent.Services.clients(params),
          callback: callback,
        }),
      create: (params, callback) =>
        dispatch({
          type: NEWBOOKING,
          payload: agent.Bookings.new_booking(params),
          callback: callback,
        }),
      order_list: (params, callback) =>
        dispatch({
          type: ORDERLIST,
          payload: agent.Bookings.order_list(params),
          callback: callback,
        }),
      payment: (params, urlParams, callback) =>
        dispatch({
          type: PAYMENTS,
          payload: agent.Bookings.payment(params, urlParams),
          callback: callback,
        }),
    }),
    [dispatch]
  );
};
